module.exports = __webpack_public_path__ + "static/media/mug-tea.a67a3447.svg";